import 'aos/dist/aos.css'
import AOS from 'aos'

document.addEventListener('DOMContentLoaded', function () {
  AOS.init({
    duration: 550
  })
})